import _regenerator from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import { aiFeedback } from '@/api/admissionCounseling/customerDrawerCom';
var __default__ = {
  props: {
    customerId: {
      type: Number,
      required: true
    },
    customerLabel: {
      type: Object,
      required: true
    },
    aiErrorReasonOpt: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      dialog: {
        isExist: false,
        visible: false,
        loading: false
      },
      form: {
        reasons: []
      }
    };
  },
  methods: {
    handleVisible: function handleVisible() {
      var dialog = this.dialog;
      !dialog.isExist && (dialog.isExist = true);
      dialog.visible = !dialog.visible;
    },
    handleLoading: function handleLoading() {
      var dialog = this.dialog;
      dialog.loading = !dialog.loading;
    },
    submitAiFeedback: function submitAiFeedback() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var handleLoading, customerId, customerLabel, form, $refs, handleVisible, $message, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              handleLoading = _this.handleLoading, customerId = _this.customerId, customerLabel = _this.customerLabel, form = _this.form, $refs = _this.$refs, handleVisible = _this.handleVisible, $message = _this.$message;
              handleLoading();
              _context.n = 1;
              return aiFeedback({
                customerId: customerId,
                customerLabelId: customerLabel.id,
                errorReasonIds: form.reasons
              }).finally(function () {
                return handleLoading();
              });
            case 1:
              res = _context.v;
              if (typeof res === 'string') {
                $refs.aiTagRef.resetFields();
                handleVisible();
                $message({
                  type: 'success',
                  message: '操作成功~'
                });
                _this.$emit('refreshAiTag');
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    handlesubmit: function handlesubmit() {
      var $refs = this.$refs,
        submitAiFeedback = this.submitAiFeedback;
      $refs.aiTagRef.validate(function (isPass) {
        if (isPass) {
          submitAiFeedback();
        } else {
          return false;
        }
      });
    }
  }
};
export default /*#__PURE__*/Object.assign(__default__, {
  __name: 'aiTagCom',
  setup: function setup(__props) {
    var rules = {
      reasons: [{
        required: true,
        message: '请选择错误原因',
        trigger: 'blur'
      }]
    };
    return {
      __sfc: true,
      rules: rules
    };
  }
});